import {Injectable} from '@angular/core';
import {PartnerModel} from '../model/partner.model';
import {PartnerSummaryModel} from '../model/partnerSummary.model';
import {AddressUtils} from '../../../../../shared/utils/address.utils';
import {MomentAdapter} from '../../../../../shared/utils/moment.utils';

@Injectable({
    providedIn: 'root'
})
export class PartnerControl {

    toString(partner: PartnerModel | PartnerSummaryModel, displayType: boolean, displayAddress: boolean, displayAdditionalProperties = true): string {
        const partnerSummary: PartnerSummaryModel = (partner instanceof PartnerModel) ? partner.summary : partner;
        let str = '<strong>' + partnerSummary.name + '</strong>';
        if (displayType === true) {
            str = str + ' <strong>' + partnerSummary.mainType.type.label + '</strong>';
        }

        if (displayAdditionalProperties) {
            partnerSummary.additionalProperties.forEach(p => {
                let value = p.value;
                // FIXME to be removed. No business info in a common module!
                if (p.key === 'BIRTHDATE') {
                    value = MomentAdapter.of(value).format('DD/MM/YYYY')
                } else if (p.key === 'PRACTITIONER_TYPE_VALUE') {
                    value = value?.label
                }

                // console.log(['additional properties', p, value]);
                str = str + ' (' + value + ')';
            });
        }
        if (displayAddress) {
            partnerSummary.addresses.forEach(value => str += ' - ' + value);
        }
        return str;
    }
}
